const PAYMENT_PARAMS = [
  "payment_intent",
  "payment_intent_client_secret",
  "redirect_status",
  "token",
  "PayerID",
  "sessionQuantity",
  "cv",
  "te",
  "therapistId",
  "proposalId",
] as const;

export function cleanPaymentParamsFromUrl(url = new URL(window.location.href)) {
  let changed = false;
  for (const param of PAYMENT_PARAMS) {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  }
  if (changed) {
    window.history.replaceState({}, "", url.toString());
  }
}

export function buildPaymentReturnUrl({
  pathname,
  sessionTimestamp,
  therapyType,
  step = 2,
  conversionValue,
  trackingEventName,
  proposalMessageId,
}: {
  pathname: string;
  sessionTimestamp?: string;
  therapyType: string;
  step?: number;
  conversionValue?: number;
  trackingEventName?: string;
  proposalMessageId?: number;
}) {
  const url = new URL(pathname, window.location.origin);
  url.searchParams.set("step", step.toString());
  if (sessionTimestamp) url.searchParams.set("date", sessionTimestamp);
  url.searchParams.set("therapyType", therapyType);
  url.searchParams.set("type", therapyType);
  if (conversionValue != null)
    url.searchParams.set("cv", conversionValue.toString());
  if (trackingEventName) url.searchParams.set("te", trackingEventName);
  if (proposalMessageId != null) {
    url.searchParams.set("proposalId", proposalMessageId.toString());
  }
  return url.toString();
}
